require('../../modules/es6.object.assign');
module.exports = require('../../modules/_core').Object.assign;



//////////////////
// WEBPACK FOOTER
// ./packages/layout/node_modules/core-js/library/fn/object/assign.js
// module id = 188
// module chunks = 0